module.exports = __webpack_public_path__ + "assets/img/img152.5cbe1dc6.png";